/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Document, Font, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import Roboto from '../../../../../assets/fonts/Roboto-Bold.ttf'
import { CriterioResponse, DescricaoCargo } from '../../../../../interfaces'
import Logo from '../../assets/LogoSah.png'

interface iProps {
  cargo: DescricaoCargo
  criterios: CriterioResponse[]
}

Font.register({
  family: 'Roboto',
  fonts: [{
    src: Roboto
  }]
})

const styles = StyleSheet.create({
  page: {
    paddingBottom: 48,
    paddingTop: 12
  },
  body: {
    paddingHorizontal: 24
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    paddingHorizontal: 24,
    paddingBottom: 16,
    borderBottom: '2px solid #66046B'
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    textAlign: 'center'
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    textAlign: 'center'
  },
  boxInformacoes: {
    borderBottom: '1px solid #000',
    paddingHorizontal: 12,
    paddingVertical: 6,
    minHeight: 34,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  paragraph: {
    fontSize: 10
  },
  itemList: {
    marginLeft: 12,
    marginBottom: 4
  },
  bullet: {
    fontSize: 10,
    marginLeft: 6
  },
  criteriaBlock: {
    marginTop: 12
  }
})

function getBoxGrupos(cargo: DescricaoCargo, titulo: string, propriedade: 'conhecimentosTecnicos' | 'habilidades' | 'atribuicoes' | 'competenciasComportamentais'): any {
  return <View wrap={false} style={{ border: '1px solid #000', display: 'flex', flexDirection: 'column', marginTop: 16 }}>
    <View style={{ justifyContent: 'center', backgroundColor: '#C9C9C9', paddingVertical: '6px', borderBottom: '1px solid #000' }}>
      <Text style={{ ...styles.sectionTitle, fontSize: '11px' }}>{titulo}</Text>
    </View>
    {Object.entries(cargo.niveis).map(([key, nivel], index) => {
      return <View style={{ display: 'flex', flexDirection: 'row' }}>
      <View
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '16%',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#F0F0F0',
          borderRight: '1px solid #000',
          borderBottom: (index === (Object.entries(cargo.niveis).length - 1)) ? 'none' : '1px solid #000'
        }}
      >
        <Text style={{ fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 10 }}>{key}</Text>
      </View>
      <View
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          width: '84%',
          backgroundColor: '#FFFFFF',
          paddingHorizontal: 18,
          paddingVertical: 12,
          borderBottom: (index === (Object.entries(cargo.niveis).length - 1)) ? 'none' : '1px solid #000'
        }}
      >
        {nivel[propriedade].map(val => { return <Text style={{ fontSize: 9, textAlign: 'justify' }}>• {val}</Text> })}
      </View>
    </View>
    })}
  </View>
}

function getBoxCriterios(cargo: DescricaoCargo, titulo: string, criterios: CriterioResponse[]): any {
  return <View style={{ border: '1px solid #000', display: 'flex', flexDirection: 'column', marginTop: 16 }}>
    <View style={{ justifyContent: 'center', backgroundColor: '#C9C9C9', paddingVertical: '6px', borderBottom: '1px solid #000' }}>
      <Text style={{ ...styles.sectionTitle, fontSize: '11px' }}>{titulo}</Text>
    </View>
    {criterios.map((c, index) => {
      return <View style={{ display: 'flex', flexDirection: 'row' }}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '16%',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#F0F0F0',
            borderRight: '1px solid #000',
            borderBottom: (index === (criterios.length - 1)) ? 'none' : '1px solid #000'
          }}
        >
          <Text style={{ fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, textAlign: 'center' }}>{c.nomeCriterio}</Text>
        </View>
        <View style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          width: '84%',
          paddingHorizontal: 18,
          paddingVertical: 12,
          backgroundColor: '#FFFFFF',
          borderBottom: (index === (criterios.length - 1)) ? 'none' : '1px solid #000'
        }}>
          {Object.entries(cargo.niveis).map(([key, nivel]) => {
            const nivelOp = nivel.criteriosPontuacao.find(e => e.criterioId === c.id)
            const opcao = c.niveis.find(n => n.id === nivelOp?.opcaoPontuacaoId)
            return <View
              style={{ display: 'flex', flexDirection: 'row', gap: '6px', maxWidth: 375 }}
            >
              <Text style={{ fontFamily: 'Roboto', fontWeight: 'bold', fontSize: 9, textAlign: 'justify' }}>{key}:</Text>
              <Text style={{ fontSize: 9, textAlign: 'justify' }}>{opcao?.nome}</Text>
            </View>
          })}
        </View>
      </View>
    })}
  </View>
}

const DescricaoCargoPDF = ({ cargo, criterios }: iProps) => (
  <Document>
    <Page size="A4" style={styles.page} wrap>
      <View style={styles.header} fixed>
        <View style={{ width: '100px' }}>
          <Image src={Logo} style={{ objectFit: 'contain', maxHeight: 40, maxWidth: '100px' }} />
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '2px', alignItems: 'center' }}>
          <Text style={{ ...styles.headerTitle, fontSize: '13px', fontFamily: 'Helvetica' }}>{cargo.nomeEmpresa}</Text>
          <Text style={{ ...styles.headerTitle }}>{cargo.nomeCargo}</Text>
        </View>
        <View style={{ width: '100px' }}>
          <Image src={cargo.logoEmpresa ?? Logo} style={{ objectFit: 'contain', maxHeight: 40, maxWidth: '100px' }} />
        </View>
      </View>
      <View
        fixed
        style={{
          position: 'absolute',
          bottom: 0,
          textAlign: 'center',
          fontSize: 9,
          backgroundColor: '#66046B',
          paddingVertical: 4,
          alignItems: 'center',
          justifyContent: 'space-between',
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          gap: 32
        }}
      >
        <View style={{ width: '15%' }}></View>
        <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Text style={{ fontSize: '9px', fontFamily: 'Roboto', fontWeight: 'bold', color: 'white' }}>DESCRIÇÃO DE CARGO E FUNÇÃO: {cargo.nomeCargo}</Text>
        </View>
        <View style={{ width: '15%' }}>
          <Image
              style={{
                height: 22,
                objectFit: 'contain'
              }}
              source="https://sigah.blob.core.windows.net/onboard/0acc742b-1a78-4d9e-9bfd-26b6c1f46c19.png"
          />
        </View>
      </View>

      <View style={styles.body}>
        <View style={{ border: '1px solid #000', display: 'flex', flexDirection: 'column' }}>
          <View style={{ justifyContent: 'center', backgroundColor: '#D6D6D6', paddingVertical: '6px', borderBottom: '1px solid #000' }}>
            <Text style={styles.sectionTitle}>IDENTIFICAÇÃO</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', backgroundColor: '#FFFFFF' }}>
            <View
              style={{
                borderRight: '1px solid #000',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center'
              }}
            >
              <View style={styles.boxInformacoes}>
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9 }}>Título do cargo:</Text>
                <Text style={styles.paragraph}>{cargo.nomeCargo}</Text>
              </View>

              <View style={styles.boxInformacoes}>
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9 }}>Área:</Text>
                <Text style={styles.paragraph}>{cargo.atuacao}</Text>
              </View>

              <View style={{ ...styles.boxInformacoes, borderBottom: 'none' }}>
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, borderBottom: 'none' }}>CBO:</Text>
                <Text style={styles.paragraph}>{cargo.cbo}</Text>
              </View>
            </View>
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <View style={styles.boxInformacoes}>
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9 }}>Hierarquia:</Text>
                <Text style={styles.paragraph}>{cargo.nivelHierarquico}</Text>
              </View>

              <View style={styles.boxInformacoes}>
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9 }}>Atuação:</Text>
                <Text style={styles.paragraph}>{cargo.atuacao}</Text>
              </View>
                <View
                style={{ ...styles.boxInformacoes, borderBottom: 'none' }}
                >
                <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, marginBottom: 2 }}>Cargos superiores:</Text>
                {cargo.cargosSuperiores && cargo.cargosSuperiores?.length > 0
                  ? (
                      cargo.cargosSuperiores.map((cs, index) => (
                      <Text key={index} style={{ ...styles.paragraph, fontFamily: 'Roboto', fontSize: 9, borderBottom: 'none', paddingBottom: 0 }}>
                        {cs.nome === '' ? ('Ninguém (topo da hierarquia)') : (cs.nome)}
                      </Text>
                      )
                      ))
                  : (
                    <Text style={{ fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, borderBottom: 'none', paddingBottom: 0 }}>
                          Ninguém (Topo da hierarquia)
                    </Text>
                    )
                }
              </View>
            </View>
          </View>
              <View style={{ ...styles.boxInformacoes, borderBottom: 'none', gap: '2px', borderTop: '1px solid #000' }}>
                {Object.entries(cargo.cargosFuturos)
                  .map(([_, cargos]) => cargos.filter(c => c !== 'Topo da hierarquia'))
                  .filter(cargos => cargos.length > 0)
                  .length === 0 && (
                    <Text style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, borderBottom: 'none' }}>
                      Nenhuma trilha de carreira disponível
                    </Text>
                )}
                {Object.entries(cargo.cargosFuturos)
                  .map(([trilha, cargos]) => {
                    const filtrados = cargos.filter(c => c !== 'Topo da hierarquia')
                    return { trilha, cargos: filtrados }
                  })
                  .filter(({ cargos }) => cargos.length > 0)
                  .map(({ trilha, cargos }, index) => (
                    <Text key={index} style={{ ...styles.paragraph, fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 9, borderBottom: 'none', paddingBottom: 0 }}>
                      {trilha}: {cargos.slice(0, 2).join(', ')}
                    </Text>
                  ))}
              </View>
        </View>

        <View style={{ border: '1px solid #000', display: 'flex', flexDirection: 'column', marginTop: 16 }}>
          <View style={{ justifyContent: 'center', backgroundColor: '#D6D6D6', paddingVertical: '6px', borderBottom: '1px solid #000' }}>
            <Text style={styles.sectionTitle}>Missão</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', backgroundColor: '#FFFFFF' }}>
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center'
              }}
            >
              <View style={{ ...styles.boxInformacoes, borderBottom: 'none' }}>
                <Text style={styles.paragraph}>{cargo.missao}</Text>
              </View>
            </View>
          </View>
        </View>

        {getBoxGrupos(cargo, 'ATRIBUIÇÕES DA FUNÇÃO', 'atribuicoes')}

        {getBoxGrupos(cargo, 'REQUISITOS COMPORTAMENTAIS DESEJÁVEIS', 'competenciasComportamentais')}

        {getBoxGrupos(cargo, 'CONHECIMENTOS TÉCNICOS DESEJÁVEIS', 'conhecimentosTecnicos')}

        {/* {getBoxGrupos(cargo, 'HABILIDADES DESEJÁVEIS', 'habilidades')} */}

        {getBoxCriterios(cargo, 'CRITÉRIOS', criterios)}

        <View wrap={false} style={{ border: '1px solid #000', display: 'flex', flexDirection: 'column', marginTop: 16 }}>
          <View style={{ justifyContent: 'center', backgroundColor: '#C9C9C9', paddingVertical: '6px', borderBottom: '1px solid #000' }}>
            <Text style={{ ...styles.sectionTitle, fontSize: '11px' }}>PONTUAÇÃO</Text>
          </View>
          {Object.entries(cargo.niveis).map(([key, nivel], index) => {
            return <View style={{ display: 'flex', flexDirection: 'row' }}>
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '16%',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#F0F0F0',
                borderRight: '1px solid #000',
                borderBottom: (index === (Object.entries(cargo.niveis).length - 1)) ? 'none' : '1px solid #000'
              }}
            >
              <Text style={{ fontWeight: 'bold', fontFamily: 'Roboto', fontSize: 10 }}>{key}</Text>
            </View>
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                width: '84%',
                backgroundColor: '#FFFFFF',
                paddingHorizontal: 18,
                paddingVertical: 12,
                borderBottom: (index === (Object.entries(cargo.niveis).length - 1)) ? 'none' : '1px solid #000'
              }}
            >
              <Text style={{ fontSize: 9, textAlign: 'justify' }}>{nivel.criteriosPontuacao
                ?.map(cp => {
                  const crit = criterios.find(c => c.id === cp.criterioId)
                  const opcao = crit?.niveis.find(n => n.id === cp.opcaoPontuacaoId)
                  return opcao?.pontuacao ?? 0
                })
                .reduce((acc, val) => acc + val, 0)
              }</Text>
            </View>
          </View>
          })}
        </View>
        {cargo.assinadoPor && <View style={{ justifyContent: 'center', marginTop: '14px', display: 'flex', flexDirection: 'row', gap: '4px' }}>
          <Text style={{ ...styles.sectionTitle, fontSize: '9px' }}>Aprovado por:</Text>
          <Text style={{ ...styles.sectionTitle, fontSize: '9px', textDecoration: 'underline' }}>{cargo.assinadoPor}</Text>
        </View>}
      </View>
    </Page>
  </Document>
)

export default DescricaoCargoPDF
